import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiSearchActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_12721_12709)",
		stroke: "#0517F8",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsx("path", { d: "M11 2.79A6.562 6.562 0 1 0 15.334 11M13.703 13.703 17.5 17.5" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.001 8.502a3.001 3.001 0 0 1 3.002-3A3.001 3.001 0 0 1 15 2.5 3.001 3.001 0 0 1 12 5.501a3.001 3.001 0 0 1 3.001 3.001Z",
			fill: "#0517F8"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_12721_12709",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgAiSearchActive;
